import './Unauthenticated.less';
import React, { Component } from 'react';
import { AppLocaleProvider, Layout } from 'sd-ui-components';
import { inject, observer } from 'mobx-react';
import showCookieSettings from '../../utils/showCookieSettings';

const { Footer } = Layout;
const {
  FormattedMessage,
  FormattedHTMLMessage,
  injectIntl
} = AppLocaleProvider;

@inject('ConfigStore')
@inject('AuthStore')
@observer
class UnauthenticatedFooter extends Component {
  render() {
    return (
      <Footer className="login-footer">
        <a href={this.props.ConfigStore.config.homeUrl} target="_blank">
          <FormattedMessage id="App.Footer.Home" defaultMessage="Home" />
        </a>
        {' | '}
        <a
          href={this.props.ConfigStore.config.privacyPolicyUrl}
          target="_blank"
        >
          <FormattedMessage
            id="App.Footer.PrivacyPolicy.ExceptUkEu"
            defaultMessage="Privacy Policy (except UK/EU)"
          />
        </a>
        {' | '}
        <a
          href={this.props.ConfigStore.config.privacyPolicyUrlUkEu}
          target="_blank"
        >
          <FormattedMessage
            id="App.Footer.PrivacyPolicy.UkEu"
            defaultMessage="Privacy Policy UK/EU"
          />
        </a>
        {' | '}
        <a
          href={this.props.ConfigStore.config.privacyNoticeUrl}
          target="_blank"
        >
          <FormattedMessage
            id="App.Footer.PrivacyNotice"
            defaultMessage="Privacy Notice"
          />
        </a>
        {' | '}
        {!this.props.AuthStore.loginInfo['appLauncher'] && (
          <a onClick={showCookieSettings} target="_blank">
            <FormattedHTMLMessage
              id="App.Footer.CookiePreferences"
              defaultMessage="Cookie Preferences"
            />
          </a>
        )}
        <br />

        <span className="login-copyright-msg">
          <FormattedHTMLMessage
            id="App.Copyright"
            description="Application copyright"
            defaultMessage="&copy; {copyrightYear} SmartDrive Systems, Inc. All rights reserved."
            values={{
              copyrightYear: new Date().getFullYear()
            }}
          />
        </span>
      </Footer>
    );
  }
}

export default injectIntl(UnauthenticatedFooter);



// WEBPACK FOOTER //
// ./src/containers/AppLayout/UnauthenticatedFooter.jsx